import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { QuestionarioRespItemModel } from '../models';


@Injectable({
  providedIn: 'root'
})
export class QuestionarioRespItemService extends BaseCrudService<QuestionarioRespItemModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'questionarioRespItem';
  }

  getByQuestionarioRespId(id: string): Observable<QuestionarioRespItemModel[]> {
    return this
      .httpClient
      .get(`${this.getApiUrl()}${this.getController()}/GetByQuestionarioRespId/${id}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  getListabyRespId(id: string): Observable<any[]> {
    return this
      .httpClient
      .get(`${this.getApiUrl()}${this.getController()}/GetListabyRespId/${id}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
